import { Sort } from '@/providers/turn/types';

export const SORT_OPTIONS: Sort = { field: 'name', order: 'ASC' };
